import axios from "axios";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const getDestinos = async (lugarSalida) => {
  const res = await client.get("/api/destinos", { params: { lugarSalida } });
  return res.data.destinos;
};

export const cotizar = async (formData) => {
  const res = await client.post("/api/cotizar", formData);
  return res.data.vehiculos;
};
